import request from '@/utils/request'


// 查询宠物品类列表
export function listCategory(query) {
  return request({
    url: '/mibo/pet-category/list',
    method: 'get',
    params: query
  })
}

// 查询宠物品类分页
export function pageCategory(query) {
  return request({
    url: '/mibo/pet-category/page',
    method: 'get',
    params: query
  })
}

// 查询宠物品类详细
export function getCategory(data) {
  return request({
    url: '/mibo/pet-category/detail',
    method: 'get',
    params: data
  })
}

// 新增宠物品类
export function addCategory(data) {
  return request({
    url: '/mibo/pet-category/add',
    method: 'post',
    data: data
  })
}

// 修改宠物品类
export function updateCategory(data) {
  return request({
    url: '/mibo/pet-category/edit',
    method: 'post',
    data: data
  })
}

// 删除宠物品类
export function delCategory(data) {
  return request({
    url: '/mibo/pet-category/delete',
    method: 'post',
    data: data
  })
}
